import {VERIFY_SUCCESS as PUSH_VERIFY_SUCCESS} from './push';

export const INIT = 'wifi/INIT';

export const FAIL = 'wifi/FAIL';

const initialState = {
    error: null,

    search: null,
    mac: null,
    ap: null,
    time: null,
    url: null,
    ssid: null,

    subscribed: false,
};

export default (state = initialState, {type, ...args}) => {
    const {id, ap, t, url, ssid, search} = args;

    switch (type) {
        case 'RESET':
            return {
                ...initialState
            };
        case PUSH_VERIFY_SUCCESS:
            return {
                ...state,
                subscribed: true
            };
        case INIT:
            return {
                ...state,
                error: null,
                search: search || state.search,
                mac: id || state.mac,
                time: t || state.time,
                ap: ap || state.ap,
                url: url || state.url,
                ssid: ssid || state.ssid,
            };
        case FAIL:
            return {
                ...state,
                error: args.error || 'Unknown error.'
            };
        default:
            return state;
    }
}

export const initWifi = (data, search) => {
    return async (dispatch) => {
        dispatch({
            ...data,
            search,
            type: INIT,
        });
    }
};


// WEBPACK FOOTER //
// ./src/redux/reducers/wifi.js